export default __webpack_public_path__ + "static/media/WStoreCat_CasinoTickets.56887eed.png";